<script setup>

</script>

<template>
    <section id="inital" class="min-vh-100 d-flex align-items-center bg-light bg-gradient text-white">
      <div class="container text-center">
        <h1 class="fw-bold display-1 text-secondary m-0">Gabriel Souza</h1>
        <p class="fw-semibold fs-5 text-primary">Desenvolvedor Web & Mobile</p>
        <a href="/portfolio/docs/Curriculo.pdf" target="_blank" class="btn btn-lg btn-dark fw-semibold shadow-sm mt-3">
            <i class="bi bi-file-earmark-text"></i> Download CV
        </a>
      </div>
    </section>
</template>
